import { Component, OnInit } from '@angular/core';
import { VersionService } from '@common/services/utility/version.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
})
export class VersionComponent implements OnInit {
  public version: string;

  constructor(private readonly versionService: VersionService) {}

  ngOnInit(): void {
    this.version = this.versionService.version;
  }
}
